


















































































































import moment from 'moment';
import Component from 'vue-class-component';
import NullFlavor from '../case-action/NullFlavor.vue';
import ItemAction from '@/components/case-action/ItemAction.vue';
import CommonButton from '../button/CommonButton.vue';
import {Mixins, Prop} from 'vue-property-decorator';
import StringUtils from '../../utils/StringUtils';
import DateMixin from '@/utils/DateMixin';
import CaseInputMixin from '@/components/input/CaseInputMixin';
import TextInput from '@/components/input/TextInput.vue';
import MessageUtils from '@/utils/MessageUtils';

@Component({
  components: {
    NullFlavor,
    ItemAction,
    CommonButton,
    TextInput,
  },
  mixins: [DateMixin, CaseInputMixin],
})
export default class DateTimePicker extends Mixins(DateMixin, CaseInputMixin) {
  @Prop({default: false}) protected readonly hasUk: boolean;
  @Prop({default: false}) protected readonly futureAllowed: boolean;
  private originValue: any = '';

  private readonly DATE_FORMAT: string = 'YYYYMMDD';

  // 달력 외부 Datetime Input value
  protected bindedValue: any = '';

  // 달력 내부 Date Input value
  protected selectedDate: any = '';
  // 달력 내부 Timepicker Input value
  protected selectedTime: any = '';

  get disabledMonth() {
    return ((month: number) => {
      if (this.futureAllowed || moment(this.today).year() > this.currentYear) {
        return false;
      }
      return month > 1 + moment(this.today).month();
    });
  }

  get supplyUk() {
    return this.hasUk;
  }

  get dateValue() {
    return this.value;
  }

  get yearUK() {
    return `${this.currentYear}UKUK`;
  }

  get MonthUK() {
    return `${moment(`${this.currentYear}, ${this.currentMonth}`, 'YYYYMM').format('YYYYMM')}UK`;
  }

  get getOriginValue() {
    return this.originValue;
  }

  get isFuture() {
    if (this.futureAllowed) {
      return false;
    }
    return (this.bindedValue && moment(this.bindedValue, this.DATE_FORMAT).format(this.DATE_FORMAT) > this.today)
        || (this.selectedDate > this.today);
  }

  public mounted() {
    if (!StringUtils.hasValue(this.getOriginValue)) {
      this.originValue = this.dateValue;
    }
  }

  public onShowCaseDatePicker() {
    this.$emit('show');
    this.initialBindDate();
  }

  public initialBindDate() {
    if (StringUtils.hasValue(this.dateValue)) {
      this.bindedValue = this.dateValue;

      // Date 바인딩
      if (this.isValidDate(this.bindedValue, this.UK_FORMATS)) {
        this.selectedDate = this.bindedValue;
      } else {
        this.selectedDate = moment(this.bindedValue, this.DATE_FORMAT).format(this.DATE_FORMAT);
      }
      // Time 바인딩
      this.DATETIME_FORMATS.forEach((format: any) => {
        if (this.isValidDate(this.bindedValue, format)) {
          this.selectedTime = moment(this.bindedValue, this.DATETIME_FORMAT).format(this.TIME_FORMAT);
        }
      });

      this.bindCurrentYearAndMonth(this.selectedDate, this.DATE_FORMAT);
    } else {
      this.selectedDate = '';
      this.selectedTime = '';
      this.bindCurrentYearAndMonth(this.today, this.DATE_FORMAT);
    }
  }

  public getDayClass(date?: number) {
    const boundDay = this.getDateByFormat(this.DATE_FORMAT, this.currentYear, this.currentMonth, date);

    // (@Prop) this.futureAllowed == true 가 아닌 경우 미래 날짜를 입력하는 것이 허용되지 않는다.
    if (date !== undefined && !this.futureAllowed && boundDay > this.today) {
      return [...this.dayClass, ['disabled']];
    }

    return this.getCommonDayClass(date, this.today, boundDay, this.selectedDate);
  }

  public getMaxYear(minYear: number, maxYear?: number) {
    if (maxYear === undefined) {
       maxYear = this.futureAllowed ? this.YEAR_MAX : 0;
    }
    return moment(this.today).year() - minYear + maxYear;
  }

  public getYear(index: number, maxYear?: number) {
    return this.getMaxYear(this.YEAR_MIN, maxYear) - index + this.YEAR_MIN;
  }

  public onClickToday() {
    this.selectedDate = this.today;
    this.selectedTime = '';
    this.bindCurrentYearAndMonth(this.today, this.DATE_FORMAT);
    this.bindDate();
    this.hide();
  }

  public onClickYearUK() {
    this.selectedDate = this.getDateByFormat('YYYY', this.currentYear);
    this.selectedTime = '';
    this.bindDate('UK');
    this.hide();
  }

  public onClickMonthUK() {
    this.selectedDate = this.getDateByFormat('YYYYMM', this.currentYear, this.currentMonth);
    this.selectedTime = '';
    this.bindDate('UK');
    this.hide();
  }

  public onDateClick(date?: number) {
    const clickedDate = this.getDateByFormat(this.DATE_FORMAT, this.currentYear, this.currentMonth, date);
    if (date === undefined) {
      return;
    }

    this.selectedDate = clickedDate;
    this.bindDate();
  }

  public onBlurInputDate() {
    this.bindedValue = this.dateValue;

    if (this.isValidDate(this.bindedValue, this.TIME_ZONE_FORMAT) && !this.isFuture) {
      return;
    }

    this.bindDate('DATETIME');
  }

  public onBlurSelectedDate() {
    this.bindDate('DATE');
  }

  public onClearInputDate() {
    this.bindedValue = '';
    this.selectedDate = '';
    this.selectedTime = '';
    this.bindDate();
  }

  public onChangeTimepicker() {
    if (!StringUtils.hasValue(this.selectedTime)) {
      this.bindDate();
    }
  }

  public onFocusTimepicker() {
    /**
     * Timepicker를 선택했을 때,
     * 1) Date가 선택되지 않았을 경우,
     * 2) UK를 선택했을 경우
     *
     * 에는 오늘 날짜로 자동 바인딩한다.
     */
    if (!StringUtils.hasValue(this.selectedDate) || this.isValidDate(this.selectedDate, this.UK_FORMATS)) {
      this.selectedDate = this.today;
    }

    // 최초 포커스 시, 00:00:00초 바인딩
    if (!StringUtils.hasValue(this.selectedTime)) {
      this.selectedTime = moment('00:00:00', this.TIME_FORMAT).format(this.TIME_FORMAT);
    }
  }

  public onBlurTimepicker() {
    this.bindDate();

    this.bindCurrentYearAndMonth(this.selectedDate, this.DATE_FORMAT);
  }


  public bindDate(type?: string) {
    MessageUtils.clear();

    this.selectedDate = this.selectedDate ?? '';
    this.selectedTime = this.selectedTime ?? '';

    if (!StringUtils.hasValue(this.bindedValue) && !StringUtils.hasValue(this.selectedDate)) {
      this.commit('');
      return;
    }

    if (type === 'DATETIME') {
      this.validateDate(this.bindedValue, type);
    } else if (type === 'DATE') {
      this.validateDate(this.selectedDate, type);
    }

    this.bindedValue = (type === 'UK') ? this.selectedDate : `${this.selectedDate}${this.selectedTime}`;
    this.commit(this.bindedValue);
  }

  public validateDate(date: any, type: any) {
    if (this.isValidDate(date, this.POSSIBLE_FORMATS) && !this.isFuture) {

      // Date 바인딩
      if (this.isValidDate(date, this.UK_FORMATS)) {
        this.selectedDate = date;
      } else {
        this.selectedDate = moment(date, this.DATE_FORMAT).format(this.DATE_FORMAT);
      }

      // Time 바인딩
      if (type === 'DATETIME') {
        if (this.isValidDate(date, this.DATETIME_FORMAT)) {
          this.selectedTime = moment(date, this.DATETIME_FORMAT).format(this.TIME_FORMAT);
        } else {
          this.selectedTime = '';
        }
      }

      this.bindCurrentYearAndMonth(date, this.DATE_FORMAT);
      this.$store.commit('setDateError', false);
    } else {
      if (date != null && date.length > 0) {
        MessageUtils.displayErrorMessage(this.$t('message.datePicker.invalidFormatMessage'));
      }

      if (this.$store.getters.isActionButtonDowned) {
        this.$store.commit('setDateError', true);
      }

      this.bindedValue = '';
      this.selectedDate = '';
      this.selectedTime = '';
      this.bindCurrentYearAndMonth(this.today, this.DATE_FORMAT);
    }
  }

  // 년, 월 바인딩
  public bindCurrentYearAndMonth(date: any, format: any) {
    this.currentYear = moment(date === '' ? this.today : date, format).year();
    this.currentMonth = 1 + moment(date, format).month();
  }

  public show() {
    this.visible = true;
  }

  public hide() {
    this.visible = false;
  }

  public onChangeInput(data: any) {
    this.commit(data);
  }

  public commit(bindedValue: any) {
    if (this.isReadOnly) {
      return;
    }

    this.$emit('input', bindedValue);
  }
}
